const Access = () => {
  return (
    <>
      <div className="custom-container">
        <div className="section has-background-light p-5">
          <h2>You don't have required permission to access this page</h2>
        </div>
      </div>
    </>
  )
}

export default Access
